module.exports = __webpack_public_path__ + "img/tick.55a04db0.svg";